export const LS_KEY_PWA_CONFIG = "pwa-config";

